import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CRow,
  CCol,
  CContainer,
  CCard,
  CCardHeader,
  CCardBody,
  CInputGroupText,
  CLink,
  CImage,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import {
	MyButton
} from '../components/index'
import { UFunc } from '../helpers/functions'

const pjson = require('../../package.json')
const Error404 = (props) => {
	const {
		setToken, setLoading,showToast,prosesExpired
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uActiveroute  		= useSelector(state => state.activeRoute);
	const uEfekapp				= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] = React.useState(false);
	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}") ;

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
	},[])

	if(UFunc.isEmpty(uTokenObj)) {
		setLoading(true); prosesExpired(); return;
	}
	
	//console.log("(Error404) uTokenObj => "+(uTokenObj));
	return (
	<>
	<CCard className="mx-1 mx-lg-5 text-center classcardbg">
		<CCardHeader className="d-md-flex justify-content-center align-items-center">
		<div className="classfontbrand align-middle">Error 404</div>
		<div className="mx-2 d-none d-md-block">&middot;</div>
		<small>Page not Found</small>
		</CCardHeader>
		<CCardBody className="px-1 px-md-2 px-lg-5">
		<CImage src={window.location.origin+"/images/img_error500.png"} height="250" />
		<div id="idcontentmsg" className="mt-3 px-lg-5">{UFunc.renderHTML((pjson.mydefault.msg400page||"UNDF").join(""))}</div>
		<MyButton 
			iconname="cilHome"
			className="classfontsmaller"
			onClick={()=>uNavigate("/dashboard")}>Menu Utama</MyButton>
		</CCardBody>
	</CCard>
	</>
	)
}	

export default Error404